import dayjs from 'dayjs'

import { T } from 'lib/tolgee'

import './index.scss'

const TOLGEE_PREFIX = 'PublicDashboard'

/**
 * @param {object} props
 * @param {string} props.companyName
 * @param {Date | string} props.createdAt
 */
const CompanyMetadata = props => {
  const { companyName, createdAt } = props

  return (
    <div className="company-metadata">
      <T
        keyName={`${TOLGEE_PREFIX}-metadata`}
        parameters={{
          companyName: companyName ?? '',
          createdAt: dayjs(createdAt ?? '').format('MMM DD, YYYY') ?? '',
          b: <b />,
        }}
      >
        {'by <b>{companyName}</b> | {createdAt}'}
      </T>
    </div>
  )
}

export default CompanyMetadata
